import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Empty } from "antd";
import { BarChartOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import StackBarchart from "./chartJs/StackBarchart";

const { Title, Text } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};
const Dashboard7_2 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านลูกค้า
        </Title>
      </div>

      {/* Empty State */}
      <div
        style={{
          height: "720px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fafafa",
          borderRadius: 16,
          border: "1px dashed #d9d9d9"
        }}
      >
        <Empty
          image={
            <BarChartOutlined
              style={{
                fontSize: 72,
                color: "#91caff"
              }}
            />
          }
          imageStyle={{ height: 80 }}
          description={
            <div>
              <Title level={4} style={{ marginBottom: 8 }}>
                ยังไม่มีข้อมูลแสดงผล
              </Title>
              <Text type="secondary">
                ข้อมูลจะปรากฏเมื่อมีการบันทึกและประมวลผลในระบบ
              </Text>
            </div>
          }
        />
      </div>
    </React.Fragment>
  );
};

export default Dashboard7_2;
